import formatCurrency from "~/kernel/money/formatCurrency";
import type { Service } from "../models/Service";
import { getPriceByEstimatedTime } from "~/booking/helpers/getPriceByEstimatedTime";

export default function formatPriceRange(service: Service) {
  const minPrice = getPriceByEstimatedTime(service.minTime, service);
  const maxPrice = getPriceByEstimatedTime(service.maxTime, service);

  if (Math.abs(maxPrice - minPrice) < 1) {
    return formatCurrency(minPrice, { includeDecimals: false });
  }

  return `${new Intl.NumberFormat("sv", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(minPrice)}-${formatCurrency(maxPrice, { includeDecimals: false })}`;
}
